// extracted by mini-css-extract-plugin
module.exports = {"search":"qLPP9PDf"};